import { ConfigurationUtility } from '../../configuration/configuration.utility';
import { DOMElementEvent } from '../../dom/DOMElementEvent.enum';
import { GTMUtils } from '../GTM.utils';
import { mapToWishlistPayloadFromOrder } from '../entity/ecommerce/wishlist/mapToWishlistPayloadFromOrderData';
import { OrderData } from '../entity';

export class AddToWishlistHandler {
    private static readonly QUERY_SELECTOR_TAG: string = '[data-js-gtm-event=add_to_wishlist]';
    private static readonly DATA_SELECTOR_TAG: string = '[data-js=gtm-order]';
    private targetCollection?: NodeListOf<HTMLElement>;

    public static canHandle(): boolean {
        return document.querySelector(AddToWishlistHandler.QUERY_SELECTOR_TAG) !== null
            && document.querySelector(AddToWishlistHandler.DATA_SELECTOR_TAG) !== null;
    }

    public handle() {
        const orderData = ConfigurationUtility.getDataFromDOM<OrderData>(document, AddToWishlistHandler.DATA_SELECTOR_TAG);

        if (!!orderData) {
            this.targetCollection = document.querySelectorAll(AddToWishlistHandler.QUERY_SELECTOR_TAG);

            this.targetCollection.forEach(target => target.addEventListener(DOMElementEvent.Click, () => {
                GTMUtils.pushGA4EcommerceToDataLayer(mapToWishlistPayloadFromOrder(orderData));
            }));
        }
    }

}
